import React from 'react';
import WeatherWidget from './WeatherWidget';
import TrendingList from './TrendingList';
import AdBox from './AdBox';

// Right-hand sidebar: live weather + advertising + trending.
export default function Sidebar({ weather = [], trending = [], ads = [] }) {
  return (
    <aside className="space-y-6">
      <WeatherWidget data={weather} />
      {ads[0] && <AdBox size={ads[0].size} label={ads[0].label} note={ads[0].note} height={250} />}
      <TrendingList items={trending} />
      {ads[1] && <AdBox size={ads[1].size} label={ads[1].label} note={ads[1].note} height={520} />}

      <div className="rounded-xl overflow-hidden border border-[#e3ece7] bg-[#eef8f2]">
        <div className="p-5 text-center">
          <h4 className="font-display font-bold text-[#0f5132] text-lg">Michigan Daily Brief</h4>
          <p className="text-sm text-[#5b6b63] mt-1">Get top Michigan headlines in your inbox, twice a day.</p>
          <div className="mt-3 flex flex-col gap-2">
            <input placeholder="Your email address" className="w-full px-3 py-2 rounded-md border border-[#cfe3d8] focus:border-[#2e9e6b] outline-none text-sm bg-white" />
            <button className="w-full bg-[#157347] hover:bg-[#0f5132] text-white font-semibold text-sm py-2 rounded-md transition-colors">Subscribe Free</button>
          </div>
        </div>
      </div>

      {ads[2] && <AdBox size={ads[2].size} label={ads[2].label} note={ads[2].note} height={250} />}
    </aside>
  );
}
